import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgArrowDownAlt = function SvgArrowDownAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#arrow-down-alt_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M21.984 12.984c0 .141-.047.375-.234.563l-8.531 8.531-8.578-8.531a.897.897 0 01-.235-.563.82.82 0 011.406-.563l3.047 3 3.422 3.376V3.046a.99.99 0 01.985-.983c.562 0 .984.421.984.984v15.75l3.375-3.328 3.047-3a.82.82 0 011.172 0c.14.14.14.375.14.515zm2.016 0c0-.75-.281-1.453-.844-2.015a2.801 2.801 0 00-3.937 0l-3.047 3V2.953A2.94 2.94 0 0013.219 0a2.94 2.94 0 00-2.953 2.953v10.969l-3.047-3c-1.078-1.078-2.86-1.078-3.985 0-.562.562-.843 1.265-.843 1.969 0 .703.28 1.453.843 1.968l8.579 8.579c.796.796 2.062.796 2.812 0l8.531-8.485c.563-.515.844-1.265.844-1.969z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "arrow-down-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "rotate(90 12 12)"
  }))));
};

export default SvgArrowDownAlt;